// import { AuthenticateTokenList, TokenForScope } from '@Types/administrator';
export interface ApiTokenData {
  orgId: string;
  orgName: string;
  apis: ApiData[];
}

export interface ApiData {
  accessToken: string;
  category: number;
  description: string;
  expiredAt: string;
  name: string;
  scope: ApiTokenScope;
  tokenType: string;
}
export interface SelectedRow {
  orgId: string;
  accessToken: string;
}
export interface ApiTokenRes {
  category: number;
  description: string;
  name: string;
  scope: ApiTokenScope;
}
interface ApiTokenScope {
  sweepingMails: boolean;
  mitigationMails: boolean;
  mitigationAccounts: boolean;
  siemSecurityEvents: boolean;
  remediationMails: boolean;
  intelligent: boolean;
}
export enum AppTokenType {
  MitigationGraphApi = 'mitigation_api',
  SocGraphApi = 'soc_graph_api',
  SocManagementApi = 'soc_management_api',
}
